import { IAvatar } from "../../components/Avatar";
import { IStateManagedEntity } from "../../helpers/state-helpers/state-action";
import { Address } from "../address";

export type TeacherDto = {
  name: string;
  lastname: string;
  phone: string;
  email: string;
  address: Address;
  qualification: string;
  internal: boolean;
  schoolId: string[];
};

export class Teacher implements IStateManagedEntity, IAvatar {
  constructor(
    public name: string,
    public lastname: string,
    public phone: string,
    public email: string,
    public address: Address,
    public qualification: string,
    public internal: boolean,
    public schoolIds: string[],
    public src?: string | undefined,
  ) {}

  get id(): string {
    return this.email;
  }

  get fullName(): string {
    return `${this.name} ${this.lastname}`;
  }

  get initials(): string {
    return `${this.name[0]}${this.lastname[0]}`;
  }

  static fromTeacherDto(dto: TeacherDto): Teacher {
    return new Teacher(
      dto.address?.name ?? dto.name,
      dto.address?.lastname ?? dto.lastname,
      dto.phone,
      dto.email,
      dto.address,
      dto.qualification,
      dto.internal,
      dto.schoolId,
    );
  }
}
